<script>
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionKey } from "../context/cinemaTileDimension";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule.js";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let { image, variationId = null, lazyLoad = false, isVeryPopular = false, personalisedUser = false, isSaleBlock = false } = $props();

    const tileDimensions = getContext(cinemaTileDimensionKey);
    const dresonRule = getContext(contentDresonRuleCtxKey);

    const MEDIUM_IMAGE_SIZE_PRESET = "$spa_ambiente$";
    const TILE_PORTRAIT_PRESET = "$tile_portrait$";
    const loadingValue = lazyLoad ? "lazy" : "eager";

    /*                                                               */
    /*                                              */
    const isCutoutOnWhite = $derived(image.clippingType === "FREIGESTELLT" && image.background === "WHITE");
    const isAmbiente = $derived(image.clippingType === "AMBIENTE");
    const buildImageUrl = (imageUrl, useAmbiente) => {
        const prefix = useAmbiente ? MEDIUM_IMAGE_SIZE_PRESET : TILE_PORTRAIT_PRESET;
        return imageUrl + "?" + prefix;
    };

    const imageSrc = $derived(buildImageUrl(image._links.external.href, isAmbiente));
    const imgClass = $derived(isCutoutOnWhite || !isAmbiente ? "cutout" : "ambiente");
</script>

<div
    class="reco_cinema__image"
    style:min-height={`${tileDimensions.minimumHeight}px`}
    style:aspect-ratio="3 / 4"
    style:position="relative"
    style:overflow="hidden"
>
    <picture>
        <source srcset="{imageSrc}&fmt=auto" />
        <img
            loading={loadingValue}
            data-src={imageSrc}
            src={lazyLoad ? "" : imageSrc}
            alt={image.altText}
            class="{lazyLoad ? 'lazy' : ''} {imgClass}"
            data-testid="image-title"
        />
    </picture>

    {#if isCutoutOnWhite && !isSaleBlock}
        <div data-testid="clean-cutout-overlay" class="reco_cinema__clean_cutout_overlay"></div>
    {/if}

    <div class="reco_cinema__image__spinner_box">
        <div class="reco_cinema__image__spinner {lazyLoad ? 'p_loader250' : ''}"></div>
    </div>

    <ft9-productbadge-v1
        team="ft6-bcn"
        feature="recoProductCampaignFlag"
        variation-id={variationId}
        context-dreson={dresonRule ?? "(und.(ja).(~.(v.1)))"}
        personalized-reco={personalisedUser}
        class="reco_cinema__ft9_deal_badge"
    >
    </ft9-productbadge-v1>

    <div class="reco_cinema__labels_wrapper">
        {#if isVeryPopular}
            <div class="reco_cinema__label-visibility reco_cinema__very-popular-tag">
                <oc-tag-v1 size="25" variant="info-primary">Sehr beliebt</oc-tag-v1>
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    @use "@otto-ec/design-tokens/tokens" as tokens;

    .reco_cinema__image {
        text-align: center;
        padding-bottom: initial;
        position: relative;
        overflow: hidden;
        max-height: 100%;
        max-width: 100%;

        img {
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            right: 50%;
            transform: translate(50%, 0);
        }

        img.ambiente {
            width: auto;
            height: auto;
            min-width: 100%;
            min-height: 100%;
            max-width: none;
        }

        img.cutout {
            height: auto;
            border-radius: tokens.$oc-semantic-border-radius-150 !important;
            padding: 10%;
        }
    }

    .reco_cinema__clean_cutout_overlay {
        border-radius: tokens.$oc-semantic-border-radius-150 !important;
        position: absolute;
        inset: 0;
        background-color: rgba(33, 33, 33, 0.06);
        pointer-events: none;
    }

    .reco_cinema__image__spinner_box {
        position: absolute;
        margin: auto;
        width: 60px;
        height: 60px;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: -1;
    }

    .reco_cinema__labels_wrapper {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 0;
        left: 0;
        flex-wrap: wrap;
        align-items: flex-start;
    }

    .reco_cinema__label-visibility {
        z-index: 1;
    }

    .reco_cinema__very-popular-tag {
        margin-left: tokens.$oc-semantic-spacing-75;
        margin-bottom: tokens.$oc-semantic-spacing-50;
    }

    .reco_cinema__ft9_deal_badge {
        position: absolute;
        width: 50px;
        height: 50px;
        z-index: 1;
        top: 12px;
        left: 12px;
        border: none;
        cursor: pointer;
    }
</style>
